function cart(
  state = {
    isBlocked: false,
    isOpen: false,
    isDisabled: true,
    isKlarnaAvailable: false,
    klarnaClientId: null,
    klarnaJsUrl: null,
  },
  action,
) {
  switch (action.type) {
    case 'RESET_CART':
      return {
        ...action.payload,
        isOpen: state.isOpen,
        isDisabled: false,
        isKlarnaAvailable: false,
      }

    case 'RESET_LINE_ITEMS':
      return { ...state, line_items: action.payload }

    case 'BLOCK_CART':
      return { ...state, isBlocked: true }

    case 'SHOW_HALF_SCREEN_CART':
      return { ...state, showHalfScreenCart: action.showHalfScreenCart }

    case 'UNBLOCK_CART':
      return { ...state, isBlocked: false }

    case 'ENABLE_CART':
      return { ...state, isDisabled: false, isOpen: false }

    case 'OPEN_CART':
      return { ...state, isOpen: true }

    case 'CLOSE_CART':
      return { ...state, isOpen: false }

    case 'SET_VARIANT_SELECTION_PROMPT':
      return { ...state, showVariantSelectionPrompt: action.payload }

    case 'SET_ADD_TO_CART_ERROR_MESSAGE':
      return { ...state, addToCartErrorMessage: action.payload }

    case 'UPDATE_SHIPPING_POLICY':
      return { ...state, shipping_policy: action.payload }

    case 'RECEIVE_INITIAL_SESSION': {
      return { ...state, ...action.payload.cart }
    }

    case 'RECEIVE_ADDRESS': {
      return { ...state, shipping_address: action.payload }
    }

    case 'RECEIVE_ORDER_PREVIEW': {
      const lineItemPrices = action.payload.line_item_prices

      if (!lineItemPrices) {
        return state
      }

      const lineItems = state.line_items.map(lineItem => {
        const item = lineItemPrices.find(li => li.line_item_id === lineItem.id)

        return {
          ...lineItem,
          total: item?.discounted_price || lineItem.total,
          discount_labels: item.discount_labels,
        }
      })

      return { ...state, line_items: lineItems }
    }

    case 'RECEIVE_KLARNA_AVAILABLE': {
      return {
        ...state,
        isKlarnaAvailable: action.payload.klarna,
        klarnaClientId: action.payload.klarnaClientId,
        klarnaJsUrl: action.payload.klarnaJsUrl,
      }
    }

    default:
      return state
  }
}

// Note that digital giftcards don't have a `fulfillment_center_id`
// of 1. This allows them to go through the order daemon and to have
// shipments against them. For more information, ask Tiago.
// For display purposes, though, we still want to bundle them into
// the "Shipping Digitally" category, as the user should not worry
// about the gory details on the backend.
const isVirtual = lineItem =>
  lineItem.is_virtual || lineItem.fulfillment_center_id === 1 || lineItem.is_digital_giftcard

export function getActiveLineItems(state) {
  return state.line_items ? state.line_items.filter(lineItem => lineItem.quantity > 0) : []
}

export function getShippableLineItems(state) {
  return getActiveLineItems(state).filter(lineItem => !isVirtual(lineItem) && !lineItem.is_preorder)
}

export function getVirtualLineItems(state) {
  return getActiveLineItems(state).filter(isVirtual)
}

export function getLineItemsShippingLater(state) {
  return getActiveLineItems(state).filter(lineItem => !isVirtual(lineItem) && lineItem.is_preorder)
}

export function getLineItemCount(state) {
  return getActiveLineItems(state).reduce((total, lineItem) => total + lineItem.quantity, 0)
}

export function getIsLineItemPresent(state, lineItemId) {
  return getActiveLineItems(state)
    .map(li => li.id)
    .includes(lineItemId)
}

export function getCartTotal(state) {
  return getActiveLineItems(state).reduce(
    (total, lineItem) => total + lineItem.price * lineItem.quantity,
    0,
  )
}

export function getCartSubtotalIncludingBundles(state) {
  return getActiveLineItems(state).reduce(
    (total, lineItem) => total + lineItem.original_price_with_bundle_applied * lineItem.quantity,
    0,
  )
}

export function getCartOriginalTotal(state) {
  return getActiveLineItems(state).reduce(
    (total, lineItem) => total + lineItem.original_price * lineItem.quantity,
    0,
  )
}

export function getBundles(state) {
  return getActiveLineItems(state).reduce((bundles, lineItem) => {
    const bundle = lineItem.bundle

    if (!bundle) {
      return bundles
    }

    const existingItems = bundles[bundle.id] || []
    return { ...bundles, [bundle.id]: [...existingItems, lineItem] }
  }, {})
}

export default cart
